module.exports = __webpack_public_path__ + "img/social-wechat.b719d9bf.svg";